import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import {
  SKIN_THEMES,
  FONT_UI,
  getThemeVars,
} from "./constants";

export default function Layout({
  children,
  dashboardData = {},
  routePage,
  activePage = "",
  activeMenu = "",
}) {
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [skinId, setSkinId] = useState(() => {
    return localStorage.getItem("skinTheme") || "navy";
  });

  const skin =
    SKIN_THEMES.find((item) => item.id === skinId) ||
    SKIN_THEMES[0];

  const themeVars = useMemo(() => {
    return getThemeVars(skin);
  }, [skin]);

  const handleSkinChange = (id) => {
    setSkinId(id);
    localStorage.setItem("skinTheme", id);
  };

  /* =========================================================
     CLEAR ALL LOGIN AND TENANT SESSION DATA
  ========================================================= */

  const clearAuthenticationData = () => {
    /*
      Keep theme before clearing localStorage.
    */
    const savedTheme =
      localStorage.getItem("skinTheme") || "navy";

    /*
      Clear every localStorage value.

      This is safer than manually removing selected keys,
      because old authentication keys may exist from previous
      versions of the application.
    */
    localStorage.clear();

    /*
      Clear sessionStorage too.

      Some login implementations use sessionStorage when
      "Remember me" is not selected.
    */
    sessionStorage.clear();

    /*
      Restore only non-authentication UI preference.
    */
    localStorage.setItem("skinTheme", savedTheme);

    /*
      Remove possible application cache values.
    */
    try {
      window.history.replaceState(
        null,
        "",
        "/"
      );
    } catch (error) {
      console.warn(
        "[Logout] Could not replace browser history:",
        error
      );
    }
  };

  /* =========================================================
     LOGOUT
  ========================================================= */

  const handleLogout = () => {
    console.log("[Logout] Logging out current user");

    clearAuthenticationData();

    /*
      Replace prevents the user from pressing Back and
      returning to the protected dashboard route.
    */
    navigate("/", {
      replace: true,
    });
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--page-bg)",
        color: "var(--text-primary)",
        fontFamily: FONT_UI,
        ...themeVars,
      }}
    >
      <Sidebar
        skin={skin}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        routePage={routePage || "/route-master"}
        onLogout={handleLogout}
        activePage={activePage}
        activeMenu={activeMenu}
      />

      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          marginLeft: "270px",
        }}
        className="layout-main-col"
      >
        <Header
          skin={skin}
          skinId={skinId}
          onSkinChange={handleSkinChange}
          dashboardData={dashboardData || {}}
          onLogout={handleLogout}
          setSidebarOpen={setSidebarOpen}
        />

        <main
          style={{
            flex: 1,
            padding: "28px 28px",
          }}
          className="layout-main-pad"
        >
          {children}
        </main>
      </div>

      <style>{`
        @media(max-width:1024px) {
          .layout-main-col {
            margin-left: 0 !important;
          }

          .layout-main-pad {
            padding: 20px 16px !important;
          }
        }
      `}</style>
    </div>
  );
}